import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from "@angular/router";
import { notificationTypes, statusCodes } from '../constants/constants';
import { iResponse } from '../interfaces/interfaces';

@Injectable({ providedIn: 'root' })
export class NotificationService
{
    constructor(private toastrService: ToastrService, private router: Router) { }

    openNotify(message: string, title: string, type: number): void {
        switch (type) {
            case notificationTypes.SUCCESS: this.toastrService.success(message, title); break;
            case notificationTypes.INFO: this.toastrService.info(message, title); break;
            case notificationTypes.WARNING: this.toastrService.warning(message, title); break;
            case notificationTypes.ERROR: this.toastrService.error(message, title); break;
            case notificationTypes.DEFAULT: this.toastrService.success(message, title); break;
        }
    }

    success(message: string) {
        this.openNotify(message, null, notificationTypes.SUCCESS);
    }

    info(message: string) {
        this.openNotify(message, null, notificationTypes.INFO);
    }

    warning(message: string) {
        this.openNotify(message, null, notificationTypes.WARNING);
    }

    error(error: any, message?: string) {
        console.log(error);
        this.openNotify(message || statusCodes.errorConexionServidor.message, null, notificationTypes.ERROR);
    }

    verifyStatus(operation: iResponse, blnNotificationOk?: boolean): boolean {
        let success = false;
        if (operation) {
            if(operation.codigo === statusCodes.ok.code){
                success = true;
                if (blnNotificationOk) this.openNotify(statusCodes.ok.message, null, notificationTypes.SUCCESS);
            }else{
                switch (operation.codigo) {
                    case statusCodes.noPermiso.code:
                        this.router.navigate(['/unauthorized']);
                        break;
                    case statusCodes.tokenExpirado.code:
                        localStorage.removeItem('authData');
                        this.router.navigate(['/auth/login']);
                        break;
                    default:
                        break;
                }
                if(blnNotificationOk){
                    const showMesage = (operation.mensaje) ? operation.mensaje : statusCodes.errorConexionServidor.message;
                    this.openNotify(showMesage, null, notificationTypes.ERROR);
                }
            }
        }
        return success;
    }
}
